import * as React from 'react';
import { AppBar, Toolbar, Typography, Container, Box, Link } from '@mui/material';
import { AuthContext } from '../auth/AuthContext';

import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';

import HomeIcon from '@mui/icons-material/Home';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import HelpIcon from '@mui/icons-material/Help';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import LogoutIcon from '@mui/icons-material/Logout';

import SearchComponent from './search/Search';

const pages = [
    { name: 'Mis Recetas', icon: MenuBookIcon, href: "/me/recipes" },
    { name: 'Nueva Receta', icon: AddCircleIcon, href: "/recipes/new" },
    { name: '¿Qué Comer Hoy?', icon: HelpIcon, href: "/recipes/suggestion" },
];
const settings = [
    { name: 'Perfil', icon: AccountBoxIcon, href: "/me" },
    { name: 'Mis Recetas', icon: MenuBookIcon, href: "/me/recipes" },
    { name: 'Logout', icon: LogoutIcon, href: "/logout" },
];

function Header() {

    const { isAuthenticated } = React.useContext(AuthContext); // Obtener el estado de autenticación

    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <Box>
            <AppBar position="static" sx={{ backgroundColor: '#FFA500' }}>
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Link href="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                            <Box
                                component="img"
                                src="/static/images/logos/logo_2.svg"
                                alt="Logo"
                                sx={{
                                    height: '50px',
                                    marginRight: '10px',
                                    display: { xs: 'none', sm: 'none', md: 'block' },
                                }}
                            />
                            <Typography
                                variant="h6"
                                noWrap
                                sx={{
                                    mr: 2,
                                    display: { xs: 'none', md: 'flex' },
                                    fontFamily: 'monospace',
                                    fontWeight: 700,
                                    letterSpacing: '.3rem',
                                    color: '#FFFFFF',
                                    textDecoration: 'none',
                                }}
                            >
                                RECETAR.IO
                            </Typography>
                        </Link>

                        <Box sx={{ flexGrow: 1, display: { s: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{
                                    display: { xs: 'block', md: 'none' },
                                }}
                            >
                                <MenuItem sx={{ display: { sm: 'block', md: 'none', l: 'none', xl: 'none' } }} key='Inicio' onClick={handleCloseUserMenu}>
                                    <Link href="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                                        <ListItemIcon>
                                            <HomeIcon fontSize="small" />
                                        </ListItemIcon>
                                        <ListItemText>Inicio</ListItemText>
                                    </Link>
                                </MenuItem>

                                {pages.map((page) => (
                                    <MenuItem key={page.name} onClick={handleCloseNavMenu}>
                                        <Link href={page.href} style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                                            <ListItemIcon>
                                                <page.icon fontSize="small" />
                                            </ListItemIcon>
                                            <Typography textAlign="center">{page.name}</Typography>
                                        </Link>
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Box>

                        <Typography
                            variant="h5"
                            noWrap
                            component="a"
                            href="#app-bar-with-responsive-menu"
                            sx={{
                                mr: 2,
                                display: { s: 'flex', md: 'none', xs: 'none' },
                                flexGrow: 1,
                                fontFamily: 'monospace',
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                color: '#FFFFFF',
                                textDecoration: 'none',
                            }}
                        >
                            RECETAR.IO
                        </Typography>
                        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                            {pages.map((page) => (
                                <Button
                                    key={page.name}
                                    onClick={handleCloseNavMenu}
                                    sx={{ my: 2, color: '#FFFFFF', display: 'block', fontWeight: 'bold' }}
                                    href={page.href}
                                >
                                    {page.name}
                                </Button>
                            ))}
                        </Box>

                        {/* Separar la barra de búsqueda y el botón de iniciar sesión */}
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <SearchComponent sx={{ marginRight: 2 }} /> {/* Usar el nuevo componente */}

                            <Box sx={{ flexGrow: 0 }}>
                                {isAuthenticated ? (
                                    <>
                                        <Tooltip title="Ajustes">
                                            <IconButton onClick={handleOpenUserMenu} sx={{ p: 2 }}>
                                                <Avatar sx={{
                                                    border: '2px solid rgba(255, 255, 255, 0.75)',
                                                    color: 'rgba(255, 255, 255, 0.75)',
                                                    backgroundColor: 'transparent',
                                                }}
                                                />
                                            </IconButton>
                                        </Tooltip>
                                        <Menu
                                            sx={{ mt: '45px' }}
                                            id="menu-appbar"
                                            anchorEl={anchorElUser}
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            keepMounted
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            open={Boolean(anchorElUser)}
                                            onClose={handleCloseUserMenu}
                                        >
                                            {settings.map((setting) => (
                                                <MenuItem key={setting.name} onClick={handleCloseNavMenu}>
                                                    <Link href={setting.href} style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                                                        <ListItemIcon>
                                                            <setting.icon fontSize="small" />
                                                        </ListItemIcon>
                                                        <Typography textAlign="center">{setting.name}</Typography>
                                                    </Link>
                                                </MenuItem>
                                            ))}
                                        </Menu>
                                    </>
                                ) : (
                                    <Button
                                        variant="outlined"
                                        color="inherit"
                                        href="/login"
                                        sx={{ 
                                            borderColor: '#FFFFFF', 
                                            color: '#FFFFFF',
                                            whiteSpace: 'nowrap', // Evitar que el texto se divida en dos líneas
                                            padding: '6px 16px', // Ajuste de padding
                                            ml: 2
                                        }}
                                    >
                                        Iniciar Sesión
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </Box>
    );
}

export default Header;
